import React, {PureComponent, ReactNode, ChangeEvent, KeyboardEvent} from 'react';
import {i18n_t} from 'app/i18n';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

interface SearchInputProps {
    handleChange: (event: ChangeEvent<HTMLInputElement>) => void,
    handleKeyPress?: (event: KeyboardEvent<HTMLInputElement>) => void,
    value: string,
    onBlur?(): void,
    onClick?(): void,
    classSearchInput?: string
    classButtonClear?: string
}

export default class SearchInput extends PureComponent<SearchInputProps> {
    render(): ReactNode {
        return <div className={`search-container ${this.props.classSearchInput ?? this.props.classSearchInput}`}>
            <span className="search-container__icon">
                <SpriteIcon name="#svg-search-icon" className="svg-default" />
            </span>
            <input
                className="search-container__input"
                type="text"
                placeholder={i18n_t('search')}
                onChange={this.props.handleChange}
                onKeyPress={this.props.handleKeyPress}
                value={this.props.value}
                onBlur={this.props.onBlur}
            />
            {this.props.value.length > 0 && <button
                className={`search-container__clear ${this.props.classButtonClear ?? this.props.classButtonClear}`}
                onClick={this.props.onClick}
            >
                <SpriteIcon name="#svg-close" className="svg-default" />
            </button>}
        </div>;
    }
}
